module.exports = __webpack_public_path__ + "static/gallery_11-6e04078bdf316c1def02bf36d4e06b93.jpg";